/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';
import { GetTeam } from './team.get';

const Params = z.strictObject({ organizationId: ZodTypes.Id, teamIdentifier: ZodTypes.Team.Identifier });

export const PatchTeam = {
  id: 'team.patch',
  tag: 'Team',
  summary: 'Patch organization team',
  description: 'Patch a team in an organization',
  method: 'patch',
  flags: { isAuthorized: true },
  route: (params: z.infer<typeof Params>) => `/organization/${params.organizationId}/team/${params.teamIdentifier}`,
  request: {
    params: Params,
    body: {
      content: {
        'application/json': {
          schema: z.strictObject({
            displayName: ZodTypes.Team.DisplayName.optional(),
            about: ZodTypes.Team.About.nullish(),
            role: ZodTypes.RBAC.Organization.Roles.optional(),
          }),
        },
      },
    },
  },
  response: { 200: GetTeam.response['200'] },
} as const satisfies Endpoint;
